import { useTranslation } from 'react-i18next';

import { Icon, ICONS } from './icon';
import { NavLink } from './nav-link';
import { localePath } from '../lib/format';
import { SITE_UI } from '@site-ui';
import { useLocale } from '@todo/core/i18n/use-locale';

import css from './mood-tiles.module.css';

// "Curated for Your Mood": the site's tiles (SITE_UI.moodTiles) — a photo per
// mood collection or other list, the label and a round arrow on a dark
// gradient at the bottom.
export function MoodTiles() {
  const { t } = useTranslation();
  const { locale } = useLocale();

  return (
    <ul className={css.grid}>
      {SITE_UI.moodTiles.map((tile) => (
        <li key={tile.path} className={css.cell}>
          <NavLink href={localePath(locale, tile.path)} className={css.tile}>
            <img className={css.photo} src={tile.image} alt="" loading="lazy" decoding="async" />
            <span className={css.shade} aria-hidden="true" />
            <span className={css.caption}>
              <span className={css.label}>{t(tile.key)}</span>
              <span className={css.arrow} aria-hidden="true">
                <Icon d={ICONS.arrowRight} size={12} strokeWidth={2} className={css.arrowIcon} />
              </span>
            </span>
          </NavLink>
        </li>
      ))}
    </ul>
  );
}
